/** Currency code for Singapore Dollar */
export const CURRENCY = "SGD" as const;

/** Default locale for Singapore market */
export const LOCALE = "en-SG" as const;

/** App display names */
export const APP_NAMES = {
  consumer: "DwellDrop",
  venue: "VenueHub Console",
  admin: "DwellDrop Admin",
} as const;

/** Format price in SGD */
export function formatPrice(cents: number): string {
  return new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: CURRENCY,
  }).format(cents / 100);
}

/** Canonical category list shared across all apps */
export const CATEGORIES = [
  { key: "fnb", label: "F&B", icon: "🍽️", color: "text-blue-500", bgColor: "bg-blue-100" },
  { key: "retail", label: "Retail", icon: "🛍️", color: "text-amber-600", bgColor: "bg-amber-100" },
  { key: "fashion", label: "Fashion", icon: "👗", color: "text-rose-600", bgColor: "bg-rose-100" },
  { key: "sports", label: "Sports", icon: "⚽", color: "text-cyan-600", bgColor: "bg-cyan-100" },
  { key: "wellness", label: "Wellness", icon: "🧘", color: "text-green-500", bgColor: "bg-green-100" },
  { key: "beauty", label: "Beauty", icon: "💄", color: "text-pink-500", bgColor: "bg-pink-100" },
  { key: "fitness", label: "Fitness", icon: "💪", color: "text-orange-500", bgColor: "bg-orange-100" },
  { key: "healthcare", label: "Healthcare", icon: "🏥", color: "text-red-500", bgColor: "bg-red-100" },
  { key: "services", label: "Services", icon: "💼", color: "text-slate-600", bgColor: "bg-slate-100" },
  { key: "entertainment", label: "Entertainment", icon: "🎬", color: "text-yellow-500", bgColor: "bg-yellow-100" },
] as const;

export type CategoryKey = (typeof CATEGORIES)[number]["key"];

export const getCategoryByKey = (key: string) =>
  CATEGORIES.find((c) => c.key === key);

/** Canonical post categories for RAG content generation */
export const POST_CATEGORIES = [
  { key: "beer", label: "Beer" },
  { key: "wine", label: "Wine" },
  { key: "cocktails", label: "Cocktails" },
  { key: "food", label: "Food" },
  { key: "burgers", label: "Burgers" },
  { key: "amenities", label: "Amenities" },
  { key: "shopping", label: "Shopping" },
] as const;

export type PostCategoryKey = (typeof POST_CATEGORIES)[number]["key"];

export const getPostCategoryByKey = (key: string) =>
  POST_CATEGORIES.find((c) => c.key === key);

export const isPostCategoryKey = (value: string): value is PostCategoryKey =>
  POST_CATEGORIES.some((c) => c.key === value);
